import { render, staticRenderFns } from "./OptionTargetFamilyListModal.vue?vue&type=template&id=19d84808&scoped=true&lang=pug"
import script from "./OptionTargetFamilyListModal.vue?vue&type=script&lang=ts"
export * from "./OptionTargetFamilyListModal.vue?vue&type=script&lang=ts"
import style0 from "./OptionTargetFamilyListModal.vue?vue&type=style&index=0&id=19d84808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d84808",
  null
  
)

export default component.exports